/*
* Commons
* -------------------------
*/
export const UPDATE_ALL_USER_LIST = "updateAllUserList"
export const CLEAR_NOTIFICATIONS = "clearNotifications"
/*
* Const Accounts
* -------------------------
*/
export const SIGN_UP_USER = 'signUpUser'
export const SIGN_UP_USER_OTHERS = 'signUpUserOthers'
export const SIGN_IN_USER = 'signInUser'
export const SIGN_OUT_USER = 'signOutUser'
export const CHECK_AUTH = 'checkAuthentication'
export const ADD_PROFILE_PIC = 'addProfilePic'
export const REMOVE_PROFILE_PIC = 'removeProfilePic'
export const UPDATE_ACCOUNT = 'updateAccount'
export const SEND_PASSWORD_RESET = 'sendPasswordReset'

/*
* Const Profiles
* -------------------------
*/
export const GET_CURRENT_USER = "getCurrentUser"
export const CLEAR_CURRENT_PROFILE_RELATED = "clearCurrentProfileRelated"
export const GET_PROFILE_POST_LIST = "getProfilePostList"
export const GET_PROFILE_SAVED_POST_LIST = "getProfileSavedPostList"
export const FOLLOW_USER = "followUser"
export const UNFOLLOW_USER = "unFollowUser"
export const GET_FOLLOWER_LIST = "getFollowerList"
export const GET_FOLLOWING_LIST = "getFollowingList"

/*
* Const Files
* -------------------------
*/
export const UPLOAD_FILE = "uploadFile"
export const DEL_FILE = "deleteFile"

/*
* Const Post 
* -------------------------
*/
export const CREATE_POST = "createPost"
export const CREATE_ATTACHMENT = "createAttachment"
export const GET_POST = "getPost"
export const DEL_POST = "deletePost"
export const GET_POST_LIST = "getPostList"
export const GET_POST_ATTACHMENTS = "getPostAttachments"
export const GET_ATTACHMENT = "getAttachment"
export const CURRENT_POST_CLEAR = "currentPostClear"
export const DEL_ATTACHMENT = "deleteAttachment"
export const LIKE_POST = "likePost"
export const UNLIKE_POST = "unlikePost"
export const UPDATE_POST_CONTENT = "updatePost"
export const UPDATE_POST_ATTACHMENT = "updatePostAttachment"
export const GET_LIKED_LIST = "getLikedList"
export const BOOKMARK_POST = "bookmarkPost"
export const DEL_BOOKMARK_POST = "delBookmarkPost"

/*
* Suggested users
* -------------------------
*/
export const GET_SUGGESTED_USERS = "getSuggestedUsers"

/*
* Search
* -------------------------
*/
export const GET_SEARCH_LIST = "getSearchList"
export const GET_SEARCH_LIST_PROFILE = "getSearchListProfile"

/*
* Explore
* -------------------------
*/
export const GET_EXPLORE_LIST = "getExploreList"